/*eslint-disable*/
import React, { useState, useEffect } from 'react'
// components
import {
  Chip,
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import {
  chipContainerStyle,
  chipTextGroupStyle,
  chipTextBoldStyle,
  chipTextStyle,
  tableHeadStyle,
  tableFirstColumnStyle,
  tableSecondColumnStyle,
  tableChipContainerStyle
} from './userGroupFieldStyle'

import { getApplicationsRoles } from '../../../../helpers/user'
import { groupRoleMapping } from './groupRoleMapper'
import { ColorCodeGroups } from '../../../../utils/general'
import { useTranslation } from 'react-i18next'

// constants
// import { MenuProps } from './userGroupsField.constants'

// const renderGroups = (groups) => {
//   return (
//     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//       {groups.map((value) => (
//         <Chip
//           key={value.display}
//           label={value.display}
//           sx={{ backgroundColor: value.color }}
//         />
//       ))}
//     </Box>
//   )
// }

const renderGroupName = (appName, groupName) => (
  <Container sx={chipTextGroupStyle}>
   {appName !== "Other" && <Typography variant="body1" sx={chipTextStyle}>{appName}</Typography>}
   {appName !== "Other" && <Typography variant="body1">&nbsp;-&nbsp;</Typography>}
    <Typography variant="body1" sx={chipTextBoldStyle}>
      {groupName}
    </Typography>
  </Container>
)

function UserGroupsField({ label, groups, readOnly = true }) {
  const [accessManagerArray, setAccessManagerArray] = useState([])
  const allGroups  = getApplicationsRoles();
   useEffect(() => {
    if (allGroups) {
      const result = groupRoleMapping(allGroups);
      setAccessManagerArray(result);
    }
   }, []);
  
  const appGroups = Object.keys(accessManagerArray)
  const colors = ColorCodeGroups(appGroups)
  const { t } = useTranslation()
    
  return (
    <TableContainer sx={{ marginTop: '12px' }} component={Box}>
      <Table sx={{ height: '519px' }}>
        <TableHead sx={tableHeadStyle}>
          <TableRow>
            <TableCell sx={tableFirstColumnStyle}>{t('user-profile-application-name')}</TableCell>
            <TableCell sx={tableSecondColumnStyle}>{t('user-profile-group-name')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody data-testid="groupsId">

          {Object.entries(accessManagerArray).map(([key, values]) => (
          <TableRow key={key}>
            <TableCell sx={tableFirstColumnStyle} component="th" scope="row">{key}</TableCell>
            <TableCell sx={tableChipContainerStyle}  align="left">
            {values.map((value, index) => (
            <Chip variant="outlined" key={index} 
            // label={key === "Other" ? value : `${key} - ${value}`}
            label={renderGroupName(key, value)}
            sx={{ borderColor: (colors[key]=='#ffffff' ? ' #959392B2': colors[key]), backgroundColor: colors[key] }}
            />
            ))}
            </TableCell>
          </TableRow>
          ))}

        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default UserGroupsField
